import React from "react";
import ModalViewDocument from "./ModalViewDocument/ModalViewDocument";
import ModalApprove from "./ModalApprove/ModalApprove";
import ModalRejected from "./ModalRejected/ModalRejected";

const Modals = ({
  setActiveModal,
  activeModal,
  selectedDocument,
  getPendingCrfa,
}) => {
  return (
    <>
      <ModalViewDocument
        open={activeModal === "document"}
        onClose={() => setActiveModal(null)}
        onApprove={() => setActiveModal("approved")}
        onReject={() => setActiveModal("rejected")}
        selectedDocument={selectedDocument}
      />
      <ModalApprove
        open={activeModal === "approved"}
        onClose={() => setActiveModal(null)}
        selectedDocument={selectedDocument}
        getPendingCrfa={getPendingCrfa}
      />
      <ModalRejected
        open={activeModal === "rejected"}
        onClose={() => setActiveModal(null)}
        selectedDocument={selectedDocument}
        getPendingCrfa={getPendingCrfa}
      />
    </>
  );
};

export default Modals;
